import { atom } from 'jotai';
import { pageStateVM, editStateVM, modelVM } from './vendor_edit_view_models';
import { AdminVendorModel } from '.././vendor_types';
import { EditStateVendor, VendorEditPageState } from './vendor_edit_types';

export const editPageStateAtom = atom<VendorEditPageState>(pageStateVM());
export const editStateAtom = atom<EditStateVendor>(editStateVM());
export const editModelAtom = atom<AdminVendorModel>(modelVM());
export const readOnlyModelAtom = atom<AdminVendorModel>(modelVM());
